module.exports = __webpack_public_path__ + "static/authoring.1c3fb369.png";